// src/components/StoreBadges.js
import React, { useMemo, useState } from "react";
import usePlatform from "../hooks/usePlatform";
import { buildQueryStringFromParams } from "../utils/platform";

import appStoreBadge from "../assets/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg";
import googlePlayBadge from "../assets/google_play_icon.png";

const IOS_URL_BASE = "https://apps.apple.com/app/6723902761";
const ANDROID_URL_BASE = "https://play.google.com/store/apps/details?id=com.braedentaylor.Toro";

function fireGtag(eventName, payload) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", eventName, payload);
  } else {
    console.log(eventName, payload);
  }
}

export default function StoreBadges({
  eventCategory = "get_app",
  params,
  className = "getapp-badges",
  showToggleOnMobile = false,
}) {
  const platform = usePlatform();
  const [forceShowBoth, setForceShowBoth] = useState(false);

  const qs = useMemo(() => buildQueryStringFromParams(params), [params]);

  const iosUrl = `${IOS_URL_BASE}${qs}`;
  const androidUrl = `${ANDROID_URL_BASE}${qs}`;

  const payloadBase = useMemo(() => {
    const safe = (k) => (params?.get(k) ? params.get(k) : "(none)");
    return {
      event_category: eventCategory,
      utm_source: safe("utm_source"),
      utm_medium: safe("utm_medium"),
      utm_campaign: safe("utm_campaign"),
      utm_content: safe("utm_content"),
    };
  }, [eventCategory, params]);

  const shouldShowIOS =
    forceShowBoth || platform === "ios" || platform === "desktop" || platform === "unknown";
  const shouldShowAndroid =
    forceShowBoth || platform === "android" || platform === "desktop" || platform === "unknown";

  return (
    <div>
      <div className={className}>
        {shouldShowIOS && (
          <a
            className="getapp-badgeLink"
            href={iosUrl}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Download Toro on the Apple App Store"
            onClick={() =>
              fireGtag("store_badge_click", { ...payloadBase, event_label: "ios" })
            }
          >
            <img className="getapp-badge" src={appStoreBadge} alt="Download on the App Store" />
          </a>
        )}

        {shouldShowAndroid && (
          <a
            className="getapp-badgeLink"
            href={androidUrl}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Get Toro on Google Play"
            onClick={() =>
              fireGtag("store_badge_click", { ...payloadBase, event_label: "android" })
            }
          >
            <img className="getapp-badge" src={googlePlayBadge} alt="Get it on Google Play" />
          </a>
        )}
      </div>

      {showToggleOnMobile && platform !== "desktop" && (
        <button
          type="button"
          className="getapp-altLink"
          onClick={() => setForceShowBoth((v) => !v)}
        >
          {forceShowBoth ? "Show my store only" : "Not your device? Show both stores"}
        </button>
      )}
    </div>
  );
}
